import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 10,
    seconds: 48
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds === 0) {
          if (prev.minutes === 0) return prev; // Stop at 00:00
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        }
        return {
          ...prev,
          seconds: prev.seconds - 1
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="fixed top-0 left-0 w-full bg-[#E63946] text-white z-50 py-2 px-4 shadow-lg" data-id="element-53">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-sm md:text-base font-bold uppercase tracking-wide" data-id="element-54">
        <Clock className="w-5 h-5 animate-pulse" data-id="element-55" />
        <span data-id="element-56">Esta oferta termina pronto:</span>
        <span className="bg-black/20 px-2 py-0.5 rounded font-mono" data-id="element-57">
          {String(timeLeft.minutes).padStart(2, '0')}:
          {String(timeLeft.seconds).padStart(2, '0')}
        </span>
      </div>
    </div>;
}